var map = {
	"./pump-0.png": "886a",
	"./pump-1.png": "47d4",
	"./pump-2.png": "5ade",
	"./pump-3.png": "f1a0",
	"./pump-4.png": "1d89",
	"./pump-false.png": "2b04",
	"./pump-true.png": "ea52",
	"./pump-undefined.png": "e21f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7a7";